export const ApplicationsConstant = {
  GET_APPLICATIONS_LIST_REQUEST: "GET_APPLICATIONS_LIST_REQUEST",
  GET_APPLICATIONS_LIST_SUCCESS: "GET_APPLICATIONS_LIST_SUCCESS",
  GET_APPLICATIONS_LIST_ERROR: "GET_APPLICATIONS_LIST_ERROR",

  GET_MANUAL_RISK_LIST_REQUEST: "GET_MANUAL_RISK_LIST_REQUEST",
  GET_MANUAL_RISK_LIST_SUCCESS: "GET_MANUAL_RISK_LIST_SUCCESS",
  GET_MANUAL_RISK_LIST_ERROR: "GET_MANUAL_RISK_LIST_ERROR",

  SET_MANUAL_RISK_LIST_REQUEST: "SET_MANUAL_RISK_LIST_REQUEST",
  SET_MANUAL_RISK_LIST_SUCCESS: "SET_MANUAL_RISK_LIST_SUCCESS",
  SET_MANUAL_RISK_LIST_ERROR: "SET_MANUAL_RISK_LIST_ERROR",

  GET_SANCTIONS_LIST_REQUEST: "GET_SANCTIONS_LIST_REQUEST",
  GET_SANCTIONS_LIST_SUCCESS: "GET_SANCTIONS_LIST_SUCCESS",
  GET_SANCTIONS_LIST_ERROR: "GET_SANCTIONS_LIST_ERROR",

  REVIEW_SANCTION_REQUEST: "REVIEW_SANCTION_REQUEST",
  REVIEW_SANCTION_SUCCESS: "REVIEW_SANCTION_SUCCESS",
  REVIEW_SANCTION_ERROR: "REVIEW_SANCTION_ERROR",

  ALL_SANCTION_REVIEWED_REQUEST: "ALL_SANCTION_REVIEWED_REQUEST",
  ALL_SANCTION_REVIEWED_SUCCESS: "ALL_SANCTION_REVIEWED_SUCCESS",
  ALL_SANCTION_REVIEWED_ERROR: "ALL_SANCTION_REVIEWED_ERROR",

  GET_DOCUMENTS_REQUEST: "GET_DOCUMENTS_REQUEST",
  GET_DOCUMENTS_SUCCESS: "GET_DOCUMENTS_SUCCESS",
  GET_DOCUMENTS_ERROR: "GET_DOCUMENTS_ERROR",

  GET_APPLICATION_REQUEST: "GET_APPLICATION_REQUEST",
  GET_APPLICATION_SUCCESS: "GET_APPLICATION_SUCCESS",
  GET_APPLICATION_ERROR: "GET_APPLICATION_ERROR",

  REJECT_APPLICATION_REQUEST: "REJECT_APPLICATION_REQUEST",
  REJECT_APPLICATION_SUCCESS: "REJECT_APPLICATION_SUCCESS",
  REJECT_APPLICATION_ERROR: "REJECT_APPLICATION_ERROR",

  REJECT_DUE_SANCTION_LIST_REQUEST: "REJECT_DUE_SANCTION_LIST_REQUEST",
  REJECT_DUE_SANCTION_LIST_SUCCESS: "REJECT_DUE_SANCTION_LIST_SUCCESS",
  REJECT_DUE_SANCTION_LIST_ERROR: "REJECT_DUE_SANCTION_LIST_ERROR",

  REQUEST_ADDITIONAL_DOCUMENTS_REQUEST: "REQUEST_ADDITIONAL_DOCUMENTS_REQUEST",
  REQUEST_ADDITIONAL_DOCUMENTS_SUCCESS: "REQUEST_ADDITIONAL_DOCUMENTS_SUCCESS",
  REQUEST_ADDITIONAL_DOCUMENTS_ERROR: "REQUEST_ADDITIONAL_DOCUMENTS_ERROR",

  APPROVE_RISK_REQUEST: "APPROVE_RISK_REQUEST",
  APPROVE_RISK_SUCCESS: "APPROVE_RISK_SUCCESS",
  APPROVE_RISK_ERROR: "APPROVE_RISK_ERROR",

  ADD_RISK_REQUEST: "ADD_RISK_REQUEST",
  ADD_RISK_SUCCESS: "ADD_RISK_SUCCESS",
  ADD_RISK_ERROR: "ADD_RISK_ERROR",

  APPROVE_BENEFICIARIES_REQUEST: "APPROVE_BENEFICIARIES_REQUEST",
  APPROVE_BENEFICIARIES_SUCCESS: "APPROVE_BENEFICIARIES_SUCCESS",
  APPROVE_BENEFICIARIES_ERROR: "APPROVE_BENEFICIARIES_ERROR",

  UPLOAD_APPLICATION_DOCUMENTS_REQUEST: "UPLOAD_APPLICATION_DOCUMENTS_REQUEST",
  UPLOAD_APPLICATION_DOCUMENTS_SUCCESS: "UPLOAD_APPLICATION_DOCUMENTS_SUCCESS",
  UPLOAD_APPLICATION_DOCUMENTS_ERROR: "UPLOAD_APPLICATION_DOCUMENTS_ERROR",

  SET_REVIEW_KYC_STATUS_REQUEST: "SET_REVIEW_KYC_STATUS_REQUEST",
  SET_REVIEW_KYC_STATUS_SUCCESS: "SET_REVIEW_KYC_STATUS_SUCCESS",
  SET_REVIEW_KYC_STATUS_ERROR: "SET_REVIEW_KYC_STATUS_ERROR",

  SET_MISSING_DOCUMENTS_REQUEST: "SET_MISSING_DOCUMENTS_REQUEST",
  SET_MISSING_DOCUMENTS_SUCCESS: "SET_MISSING_DOCUMENTS_SUCCESS",
  SET_MISSING_DOCUMENTS_ERROR: "SET_MISSING_DOCUMENTS_ERROR",

  MODIFY_SELECTED_APP_STATE: "MODIFY_SELECTED_APP_STATE",
  MODIFY_SELECTED_APP_ACTIONS: "MODIFY_SELECTED_APP_ACTIONS",
  CLEAR_SINGLE_APP_STATE: "CLEAR_SINGLE_APP_STATE",
  CLEAR_APPROVED_RISKS: "CLEAR_APPROVED_RISKS",

  CONFIRM_UPLOADED_AGREEMENTS_REQUEST: "CONFIRM_UPLOADED_AGREEMENTS_REQUEST",
  CONFIRM_UPLOADED_AGREEMENTS_SUCCESS: "CONFIRM_UPLOADED_AGREEMENTS_SUCCESS",
  CONFIRM_UPLOADED_AGREEMENTS_ERROR: "CONFIRM_UPLOADED_AGREEMENTS_ERROR",

  REJECT_UPLOADED_AGREEMENTS_REQUEST: "REJECT_UPLOADED_AGREEMENTS_REQUEST",
  REJECT_UPLOADED_AGREEMENTS_SUCCESS: "REJECT_UPLOADED_AGREEMENTS_SUCCESS",
  REJECT_UPLOADED_AGREEMENTS_ERROR: "REJECT_UPLOADED_AGREEMENTS_ERROR",

  GET_CLIENT_RISKS_LIST_REQUEST: "GET_CLIENT_RISKS_LIST_REQUEST",
  GET_CLIENT_RISKS_LIST_SUCCESS: "GET_CLIENT_RISKS_LIST_SUCCESS",
  GET_CLIENT_RISKS_LIST_ERROR: "GET_CLIENT_RISKS_LIST_ERROR",

  UPDATE_RISK_HIT_REQUEST: "UPDATE_RISK_HIT_REQUEST",
  UPDATE_RISK_HIT_SUCCESS: "UPDATE_RISK_HIT_SUCCESS",
  UPDATE_RISK_HIT_ERROR: "UPDATE_RISK_HIT_ERROR",

  GET_APPLICATIONS_EXCEL_LIST_ERROR: "GET_APPLICATIONS_EXCEL_LIST_ERROR",

  GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_REQUEST: "GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_REQUEST",
  GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_SUCCESS: "GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_SUCCESS",
  GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_ERROR: "GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_ERROR",

  RENEW_KYC_REQUEST: 'RENEW_KYC_REQUEST',
  RENEW_KYC_SUCCESS: 'RENEW_KYC_SUCCESS',
  RENEW_KYC_ERROR: 'RENEW_KYC_ERROR',

  RETRY_PREFILL_REQUEST: 'RETRY_PREFILL_REQUEST',
  RETRY_PREFILL_SUCCESS: 'RETRY_PREFILL_SUCCESS',
  RETRY_PREFILL_ERROR: 'RETRY_PREFILL_ERROR'
};
